const layout = () => import(/* webpackChunkName: "layout" */ '@/components/layout');

export default [
  {
    path: '',
    component: layout,
    children: [
      {
        name: 'orderList',
        component: () => import(/* webpackChunkName: "b2b_order_management" */ '@/pages/Order/OrderList'),
        meta: {
          title: '订单管理'
        },
        path: '/orderList'
      },
      {
        name: 'confirmOrder',
        component: () => import(/* webpackChunkName: "b2b_order_confirm" */ '@/pages/Order/ConfirmOrder'),
        meta: {
          title: '确认订单',
          keepAlive: true
        },
        path: '/confirmOrder'
      },
      {
        path: '/orderPay/:orderSn',
        name: 'orderPay',
        component: () => import(/* webpackChunkName: "b2b_order_pay" */ '@/pages/Order/OrderPay'),
        meta: {
          title: '订单支付'
        }
      },
      {
        path: '/orderDetail',
        name: 'orderDetail',
        component: () => import(/* webpackChunkName: "b2b_order_detail" */ '@/pages/Order/OrderDetail'),
        meta: {
          title: '订单详情'
        }
      }
    ]
  }
];
